const BADGE_THRESHOLD_DAYS = 3;

export function computeRegistrationDeadlineBadge(
  registrationDeadline?: string | null,
  now: Date = new Date(),
): { showBadge: boolean; count: number; unit: "day" | "hour" } {
  if (!registrationDeadline) {
    return { showBadge: false, count: 0, unit: "day" };
  }

  const diffMs = new Date(registrationDeadline).getTime() - now.getTime();
  const daysLeft = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  const showBadge = daysLeft > 0 && daysLeft <= BADGE_THRESHOLD_DAYS;

  // Within the final day, "1 day left" overstates the time remaining — switch
  // the badge to hours (ceil, so 2.5h → "3 hours left").
  if (diffMs > 0 && diffMs < 24 * 60 * 60 * 1000) {
    return {
      showBadge,
      count: Math.ceil(diffMs / (1000 * 60 * 60)),
      unit: "hour",
    };
  }
  return { showBadge, count: daysLeft, unit: "day" };
}
